<template>

  <t-page>

    <TypeFeatureDialog :no-option-add="noOptionAdd" @onSubmit="onTypeFeatureDialog"/>

    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <template #default="{status}">

      <t-input v-model="form.featureId" hidden/>

      <t-form-card title="Dados Básicos">

        <t-input v-model="form.name"  :add-error="error.name" label="Nome" required/>

        <t-input v-model="form.typeFeatureId"
                 :options="typeFeatureOptions"
                 label="Tipo de Característica" select required>

          <template #no-options="{search}">
            <b-link @click="addNoOption('modal-type-feature',search)">Cadastrar Tipo</b-link>
          </template>

          <template #input-group-append>
            <t-button title="Adicionar novo tipo" @click="openDialogForm('modal-type-feature')"
                      icon-plus/>
          </template>

        </t-input>

        <t-page-form-field-customized
            :command="command" :status="status" :user-auth="userAuth"
            :fields-customizable="entityFieldCustomized('page')"
            :primary-key="form.featureId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
            :primary-key-column="fieldKey" foreign-key-column="pageId"
        />

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </t-form-card>




      <t-form-card title="Grupos de produtos" icon-folder>

        <b-form-checkbox class="col-sm-12 ml-2" v-model="form.availableAllGroups" switch>
          Disponibilizar esta característica a todos os grupos de produtos?
          <t-help
              title="Você poderá especificar quais os produtos podem utilizar esta característica, basta desmarcar esta opção e selecionar os grupos de produtos desejados."/>
        </b-form-checkbox>

        <div v-show="!form.availableAllGroups" class="mt-2">

          <div v-for="family in groupProductOptions" :key="family.groupId" class="pb-2 mb-2 border-bottom">

            <h6 class="mb-0"><b>{{ family.groupLabel }}</b></h6>

            <div class="mb-2">
              <small>
                <b-link @click="selectGroup(true,family.options)">Todos</b-link>
                |
                <b-link @click="selectGroup(false,family.options)">Nenhum</b-link>
              </small>
            </div>

            <b-form-checkbox class="ml-3" v-for="item in family.options" :key="item.value"
                             :checked="form.groupsProduct.find(a => a.groupProductId === item.value) != null"
                             @change="addGroupSelected($event,item.value)">
              {{ item.text }}
            </b-form-checkbox>

          </div>

        </div>

      </t-form-card>


      </template>


    </t-page-form>

  </t-page>

</template>

<script>

import TypeFeatureDialog from "@/views/modules/product/TypeFeatureDialog"
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import groupProductService from "@/services/modules/product/GroupProduct.service";
import typeFeatureService from "@/services/modules/product/TypeFeature.service";


import ui from "@/assets/scripts/ui";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'FeatureForm',
  components: {TypeFeatureDialog},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields:true,
      fieldKey: "featureId",
      form: {
        featureId: 0,
        typeFeatureId: 0,
        name: "",
        note: "",
        availableAllGroups: true,
        groupsProduct: [],
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      typeFeatureOptions: [],
      groupProductOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list

        for (let group of this.groupProductOptions) {
          for (let item of group.options) {
            item.checked = false
          }
        }

      }).catch(error => this.responseError(error))


      await typeFeatureService.selectList().then((list) => {
        this.typeFeatureOptions = list
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true

    },
    async onSubmit() {


      if (!this.form.availableAllGroups && this.form.groupsProduct.length === 0) {
        ui.msgError(this, "Você marcou a opção de especificar grupos para esta característica, porém não selecionou nenhum grupo. Desmarque a opção ou selecione pelo menos 1(um) grupo antes de continuar.")
      } else {
        await this.setSendingDefault()
      }


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    addGroupSelected(checked, id) {

      if (checked) {
        //Adicionar
        const el = this.form.groupsProduct.find(a => a.groupProductId === id)
        if (el == null)
          this.form.groupsProduct.push({groupProductId: id})
      } else {
        //Remover
        const indexRemove = this.form.groupsProduct.findIndex(a => a.groupProductId === id)

        if (indexRemove >= 0)
          this.form.groupsProduct.splice(indexRemove, 1)

      }

    },

    selectGroup(checked, array) {

      for (const el of array) {
        this.addGroupSelected(checked, el.value)
      }

    },

    onTypeFeatureDialog(itemInserted) {

      this.form.typeFeatureId = itemInserted.value
      this.typeFeatureOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
